import React, {
  useCallback, useEffect, useState, useRef, useContext,
} from 'react';
import {
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
  Grid,
} from '@material-ui/core';

import getBlobDuration from 'get-blob-duration';
import { LoadingFrame, Player } from '../../../..';
import { useId } from '../../../../../hooks/index';
import { UploadRecordContext } from '../../../record/UploadRecordContext';
import CloseAction from './actions/closeAction';
import useStyles from './styles';
import FeelRecord from './feelRecord';
import { detectIOS } from '../../../../../utility/helpers';


const RecordPreviewModal = () => {
  const classes = useStyles();

  const id = useId();
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('md'));
  const refPreviewContent = useRef<HTMLDivElement | null>(null);
  const [videoSource, setVideoSource] = useState('');
  const { openPreviewModal, currentStream, setOpenPreviewModal } = useContext(UploadRecordContext);
  const [duration, setDuration] = useState<number>(0);

  const onClose = useCallback(() => {
    window.URL.revokeObjectURL(videoSource);
    setVideoSource('');
    setOpenPreviewModal(false);
  }, [setOpenPreviewModal, videoSource, setVideoSource]);

  useEffect(() => {
    if (openPreviewModal && currentStream && !videoSource) {
      const type = detectIOS ? 'video/mp4' : 'video/webm';
      const blob = new Blob(currentStream.blob, {
        type,
      });
      getBlobDuration(blob).then((blobDuration) => setDuration(blobDuration));
      setVideoSource(URL.createObjectURL(blob));
    }
  }, [currentStream, openPreviewModal, videoSource, setVideoSource]);
  return (
    <Dialog
      open={openPreviewModal}
      disableBackdropClick
      fullWidth
      aria-labelledby={id}
      maxWidth={compact ? 'xl' : 'lg'}
      disablePortal
      BackdropProps={{
        className: classes.backdrop,
      }}
      PaperProps={{
        className: classes.paperRoot,
      }}
      style={{ zIndex: 2147483102 }}
      className={classes.noselect}
      onEscapeKeyDown={onClose}
    >
      <Grid container className={classes.header} id={id}>
        <Grid item>
          <CloseAction onClick={onClose} />
        </Grid>
        <Grid item style={{ maxWidth: 'calc(100% - 40px)' }}>
          <div className={classes.title}>{currentStream?.name}</div>
          <div className={classes.uploaded}>
            {currentStream?.timestamp}
          </div>
        </Grid>
      </Grid>
      <DialogContent className={classes.content}>
        <div className={classes.recordPreviewContainer}>
          {videoSource && currentStream
            ? <Player duration={duration} src={videoSource} type="video/webm" refPreviewContent={refPreviewContent} />
            : <LoadingFrame customClassName={classes.loadingFrame} />}
        </div>
          <FeelRecord currentVideo = {currentStream} closeModal={onClose}/>
      </DialogContent>
    </Dialog>
  );
};

export default RecordPreviewModal;
